import { useState, useEffect } from 'react'
import {  Row, Col, Image, Modal, Form, Button, Spinner } from 'react-bootstrap'
import { useRouter } from 'next/router';
import { Request } from '@group-devs/yfp7-global-modules'
import Authenticator from '@group-devs/yfp7-authenticator'

import Recaptcha from '../general/Recaptcha';

const request = new Request(process.env.apiDomain)

const FreeReportWYDModal = (props) => {

    let site = props.global.site

    const { data: ownerAccount } = request.account.swrAccountProfile(site ? site.accountId : '')

    const router = useRouter()
    const [verified, setVerified] = useState(false)
    const [validationUrl, setUrl] = useState('')
    const [loading, setLoading] = useState(false)

    const [data, setData] = useState({
        firstname: '',  
        lastname: '',
        email: '',
    })
    const [errorMsg, setErrorMsg] = useState({
        firstname: '',  
        lastname: '',
        email: '',
        recaptcha: '',
    })

    useEffect(() => {
        let url, host;
        host = new URL(window.location.href);
        url  = new URL(`${host.protocol}//${host.host}/api/post`);
        url.searchParams.append('action', 'optin')
        setUrl(url)
    }, [])

    const handleChange = (evt) => {
        const value = evt.target.value
        setData({
          ...data,
          [evt.target.name]: value
        })
    }

    const checkVerification = verified => {
        setVerified(verified)
        setErrorMsg({})
    }

    const checkErrMsgs = () => {
        var err = 0;
        const errList = Object.entries(errorMsg).map(([key,value])=>{
            if (value != null || value != "")
                err++;
        },[err])
  
        if (err)
            return false
        
        return true
    }

    const fetchResponseErrors = (responseErr) =>
    {
        let errData = {};

        const errList = Object.entries(responseErr).map(([key,value])=>{
            const errField = key.toString();
            const errValue = value.toString();
            var errors = Object.assign({}, errData);
            errors[errField] = errValue;
            errData = errors;
        })
        
        setErrorMsg(errData);
    }

    function inputValidation () {
        let err = 0
        var errors = {};

        if (data.firstname == "") {
            errors['firstname'] = "Firstname is required.";
            err++;
        }

        if (data.lastname == "") {
            errors['lastname'] = "Lastname is required.";
            err++;
        }

        if (data.email == "") {
            errors['email'] = "Email is required.";
            err++;
        }

        if (!verified) {
            errors['recaptcha'] = "Required.";
        }

        setErrorMsg(errors)

        if (err)
            return false
        
        return true
    }

    async function onSubmit () {
        
        if (loading) return;  // Prevent submission if already loading

        setLoading(true); // Set loading to true when the form is being submitted

        if (inputValidation() && checkErrMsgs()) {
            let newData, post, meta_data, metaDataDetails

            metaDataDetails = {
            code: site.site.code,
            name: site.site.name
            }

            meta_data = Buffer.from(JSON.stringify(metaDataDetails)).toString('base64')

            newData = {
            websiteId: site.websiteId,
            meta_data: meta_data,
            userId: ownerAccount ? ownerAccount.userId : ''
            }

            post = {...data, ...newData}
            
            const _response = await fetch(validationUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(post)
              })
              .then((response) => { return response.json() })
              .catch(function(error) { console.log(error) })
                
                setLoading(false); // Set loading to false once the response is received or an error occurs

              let newResponse = JSON.parse(_response);

              if (typeof newResponse === 'object'){
                if (newResponse.code === 200) {
                    router.push("/what-your-doctor-wasnt-taught/confirmation")
                }else{
                    if (typeof newResponse.error === 'string') {
                    var errors = newResponse.error
                    fetchResponseErrors(JSON.parse(errors));
                    }
                }
            }
        }else {
            setLoading(false); // Ensure loading is stopped if validation fails
        }
    }

    return (
        <>
            <Modal {...props} size="lg" aria-labelledby="wyd-modal" className="section-modal-download">
                <Modal.Header closeButton>
                    <Modal.Title id="wyd-modal"></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={4}>
                            <Image src="../images/wyd/img-ebook-doctor04.png" alt="Free Report" className="img-fluid d-block w-auto mx-auto"/>
                        </Col>
                        <Col md={8}>
                            <h2><span className="text-free-report">Download my free report and discover</span>
                            What your Doctor wasn't taught in med school<br/>
                            <span className="text-about-nutrition">about nutrition that you need to know</span></h2>
                            <p>Enter your details below so I can send you this critically important report.</p>
                            <Form id="doctor-lcw">
                                <Form.Group controlId="firstname">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter your First Name.."
                                        name="firstname"
                                        value={data.firstname}
                                        onChange={handleChange}
                                    />
                                    <Form.Text className="text-danger">{errorMsg.firstname}</Form.Text>
                                </Form.Group>
                                <Form.Group controlId="lastname">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter your Last Name.."
                                        name="lastname"
                                        value={data.lastname}
                                        onChange={handleChange}
                                    />
                                    <Form.Text className="text-danger">{errorMsg.lastname}</Form.Text>
                                </Form.Group>
                                <Form.Group controlId="email">
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter your Email Address.."
                                        name="email"
                                        value={data.email}
                                        onChange={handleChange}
                                    />
                                    <Form.Text className="text-danger">{errorMsg.email}</Form.Text>
                                </Form.Group>
                                <Form.Group>
                                    <Recaptcha checkVerification={checkVerification} />
                                    <Form.Text className="text-danger">{errorMsg.recaptcha}</Form.Text>
                                </Form.Group>

                                <Button variant="btn btn-send-report" type="button" onClick={onSubmit} disabled={loading}>
                                    {loading ? "Processing..." : "Send me the Report"}
                                    {loading && <Spinner animation="border" size="sm" className="ml-2" />}
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <p className="privacy">Your email is safe with me. I'll never sell or rent your details to anyone, for any reason ever!</p>
                    <p className="testimonial"><em>"This was really helpful! I really enjoyed the information found in this report."</em> <strong>- Sarah F.</strong></p>
                </Modal.Footer>
            </Modal>
            <style jsx global>{`

                .section-modal-download {
                    font-weight: 300;
                    font-size: 16px;
                }

                .section-modal-download .modal-header {
                    border: none;
                }

                .section-modal-download .modal-header .close {
                    opacity: 1;
                    background: #000;
                    border: 2px solid #fff;
                    color: #fff;
                    font-size: 24px;
                    padding: 3px 7px 4px 8px;
                    margin: -30px -30px 0px 0px;
                    border-radius: 50%;
                }

                .section-modal-download h2 {
                    font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                    font-size: 32px;
                    margin-top: -10px;
                    margin-bottom: 20px;
                    padding-bottom: 30px;
                    border-bottom: 1px dotted #ccc;
                }

                .section-modal-download h2 .text-free-report {
                    color: #00aec7;
                    display: block;
                    margin-top: 0px;
                }

                .section-modal-download h2 .text-about-nutrition {
                    font-family: 'Poppins', Helvetica, Arial, sans-serif;
                    font-weight: 300;
                    font-size: 20px;
                    line-height: 25px;
                    display: block;
                }

                .section-modal-download .text-enter-details {
                    margin-bottom: 5px;
                }

                .section-modal-download form {
                    max-width: 400px;
                }

                .section-modal-download form .form-control {
                    height: 39px;
                    border-radius: 2px;
                    border: 1px solid #999;
                    font-size: 17px;
                }

                .section-modal-download .btn-send-report {
                    font-weight: 700;
                    font-size: 20px;
                    background: #FFD504;
                    padding: 8px 35px 10px;
                    border-radius: 0px;
                    color: #C20000;
                    border-bottom: 4px solid #DF9B3A;
                }

                .section-modal-download .btn-send-report:hover {
                    background: #D9B300;
                }

                .section-modal-download .btn-invisible-white {
                    font-weight: 300;
                    font-size: 16px;
                    background: #fff;
                    padding: 8px 25px 10px;
                    border-radius: 0px;
                    color: #006DD9;
                }

                .section-modal-download .btn-invisible-white:hover {
                    text-decoration: underline;
                }

                .section-modal-download .modal-footer {
                    border: none;
                    text-align: center;
                    padding-top: 0px;
                }

                .section-modal-download .modal-footer .privacy {
                    font-size: 14px;
                }

                .section-modal-download .modal-footer .testimonial {
                    font-size: 18px;
                }

                @media (max-width: 767.98px) {	

                    .section-free-report .container {
                        padding-top: 20px;
                    }

                    .section-free-report h2 {
                        font-size: 37px;
                        margin-top: -40px;
                        margin-bottom: 25px;
                    }

                    .section-free-report h2 .text-free-report {
                        margin-bottom: 0px;
                    }

                    .section-free-report img {
                        margin: 0px auto;
                    }

                    .section-free-report .btn-download {
                        font-size: 34px;
                        padding: 7px 35px 2px;
                    }

                }

            `}</style>
        </>
    )
}

export default FreeReportWYDModal